import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from '../app/providers/StoreProvider';
import { AppRouter } from './providers/RouterProvider';
import { antdTheme } from './styles/antd-theme';
import { usePushRegistration } from './usePushRegistration';

export function App() {
  // Регистрируем браузер как устройство — иначе заказы и задачи
  // приходят только в приложение сотрудника, а управляющий сидит
  // в кабинете.
  usePushRegistration();

  return (
    <ConfigProvider locale={ruRU} theme={antdTheme}>
      <StoreProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </StoreProvider>
    </ConfigProvider>
  );
}
